
const orderStatus = [{
	value: 1000,
	name: '待付款',
	key: "'WaitPayment'",
},
{
	value: 2000,
	name: '待处理',
	key: "'WaitProcess'",
},
{
	value: 3000,
	name: '已处理',
	key: "'Processed'",
},
{
	value: 6000,
	name: '已完成',
	key: "'Confirmed'",
},
{
	value: 9000,
	name: '已取消',
	key: "'Cancelled'",
},
]


const gender = [{
	value: 0,
	name: '男',
	key: "Male"
},
{
	value: 1,
	name: '女',
	key: "Female"
},
]

const paymentMode = [{
	value: 0,
	name: '微信支付',
	key: "WeChatPay"
},
{
	value: 1,
	name: '微信支付退回',
	key: "WeChatPayRefund"
},
{
	value: 2,
	name: '充值账户扣款',
	key: "PrepaidDeduction"
},
{
	value: 3,
	name: '充值账户退回',
	key: "PrepaidRefund"
},
{
	value: 500,
	name: '转账',
	key: 'Transfer'
},
{
	value: 900,
	name: '系统外',
	key: "OutsideSystem"
}
]

const paymentStatus = [{
	value: 1000,
	name: '待支付',
	key: "WaitPayment"
},
{
	value: 5000,
	name: '已付款',
	key: "Paid"
},
{
	value: 6000,
	name: '付款失败',
	key: "PayFailed"
}
// {
// 	value: 8000,
// 	name: '已退款',
// 	key: "Refund"
// },
// {
// 	value: 9000,
// 	name: '已取消',
// 	key: "Cancelled"
// }
]

const fileTypes = [{
	value: 0,
	name: '图片',
	key: "Image"
},
{
	value: 1,
	name: '视频',
	key: "Video"
}
]

const afterSalesStatus = [{
	value: 0,
	name: '待审核',
	key: "New"
},
{
	value: 100,
	name: '审核通过',
	key: "PassAudit"
},
{
	value: 200,
	name: '已退货',
	key: "Returned"
},
{
	value: 300,
	name: '收到退货/已派施工',
	key: "Received"
},
{
	value: 400,
	name: '换货已发货/施工已服务',
	key: "Processd"
},
{
	value: 600,
	name: '已确认',
	key: "Confirmed"
},
{
	value: 900,
	name: '已取消',
	key: "Cancelled"
}
]

const afterSaleReason = [{
	value: 0,
	name: '产品质量原因',
	key: 'Product'
},
{
	value: 300,
	name: '施工安装原因',
	key: 'Construction'
},
{
	value: 600,
	name: '物流服务原因',
	key: 'Logistics'
},
{
	value: 900,
	name: '其他原因',
	key: 'Cancelled'
}
]

const afterSaleAction = [{
	value: 0,
	name: '待审待定',
	key: 'New'
},
{
	value: 300,
	name: '退货退款',
	key: 'Return'
},
{
	value: 600,
	name: '退货换货',
	key: 'Exchange'
},
{
	value: 800,
	name: '重新施工',
	key: 'ReService'
},
{
	value: 900,
	name: '取消售后',
	key: 'Cancelled'
}
]

const paymentPurpose = [{
	value: 100,
	name: '购买',
	key: 'Buy'
},
{
	value: 200,
	name: '退款',
	key: 'Refund'
},
{
	value: 300,
	name: '充值',
	key: 'Prepaid'
},
{
	value: 500,
	name: '售后',
	key: 'AfterSales'
}
]

const organizationType = [{
	value: 0,
	name: '平台',
	key: 'Platform'
},
{
	value: 1,
	name: '供应商',
	key: 'Supplier'
},
{
	value: 2,
	name: '服务商',
	key: 'ServiceProvider'
},
{
	value: 3,
	name: '门店',
	key: 'Store'
},
{
	value: 4,
	name: '物流公司',
	key: 'Logistics'
}
]


const position = [{
	value: 0,
	name: '系统管理员',
	key: 'System'
},
{
	value: 2,
	name: '业务管理员',
	key: 'Admin'
},
{
	value: 4,
	name: '销售',
	key: 'Sale'
},
{
	value: 8,
	name: '技师',
	key: 'Technician'
}
]


const ScheduleType = [
	{ key: 'OneTime', name: 'OneTime', value: 0 },
	{ key: 'Interval', name: 'Interval', value: 1 },
	{ key: 'Daily', name: 'Daily', value: 2 },
	{ key: 'Weekly', name: 'Weekly', value: 3 },
	{ key: 'Monthly', name: 'Monthly', value: 4 },
]

const RunningMode = [
	{ key: 'Singleton', name: '一服务器一实例', value: 0 },
	{ key: 'ByMachine', name: '单实例', value: 1 },
	{ key: 'Extent', name: '可扩展', value: 2 },
]

const LoggingLevel = [
	{ key: 'Trace', name: 'Trace', value: 0 },
	{ key: 'Debug', name: 'Debug', value: 1 },
	{ key: 'Information', name: 'Information', value: 2 },
	{ key: 'Warning', name: 'Warning', value: 3 },
	{ key: 'Error', name: 'Error', value: 4 },
	{ key: 'Critical', name: 'Critical', value: 5 },
	{ key: 'None', name: 'None', value: 6 },
]

const productShelfStatus = [
	{ key: 'SupplyOffShelf', name: '编辑准备中', value: 0 },
	{ key: 'SupplyOnShelf', name: '待平台审核', value: 1 },
	{ key: 'PlatOnShelf', name: '平台已上架', value: 2 },
	{ key: 'PlatOffShelf', name: '平台已下架', value: 3 },
	{ key: 'PlatRejectShelf', name: '审核未通过', value: 3 }]

export default {
	orderStatus,
	gender,

	paymentMode,
	paymentPurpose,
	paymentStatus,

	fileTypes,
	afterSalesStatus,
	afterSaleReason,
	afterSaleAction,
	
	organizationType,
	position,
	ScheduleType,
	RunningMode,
	LoggingLevel,
	productShelfStatus
}